var map = {
	"./de.mjs": [
		73840,
		"node_modules_angular_common_locales_de_mjs"
	],
	"./en.mjs": [
		39032,
		"node_modules_angular_common_locales_en_mjs"
	],
	"./extra/de.mjs": [
		29761,
		"node_modules_angular_common_locales_extra_de_mjs"
	],
	"./extra/en.mjs": [
		18293,
		"node_modules_angular_common_locales_extra_en_mjs"
	],
	"./extra/fr.mjs": [
		99704,
		"node_modules_angular_common_locales_extra_fr_mjs"
	],
	"./extra/it.mjs": [
		44779,
		"node_modules_angular_common_locales_extra_it_mjs"
	],
	"./extra/kde.mjs": [
		47622,
		"node_modules_angular_common_locales_extra_kde_mjs"
	],
	"./fr.mjs": [
		45669,
		"node_modules_angular_common_locales_fr_mjs"
	],
	"./it.mjs": [
		38462,
		"node_modules_angular_common_locales_it_mjs"
	],
	"./kde.mjs": [
		71737,
		"node_modules_angular_common_locales_kde_mjs"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 11940;
module.exports = webpackAsyncContext;